import React, { Component } from 'react';
import { isEmpty, get, cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Table from "../../../../components/CustomTable";

import { PERMISSION } from '../../../../constants/permission';
import { checkTablePermission, checkAddPermission } from '../../../../utils/route-auth';

// import Table from '../../../components/CustomTable';
import ModalConfirmation from '../../../../components/ModalConfirmation';
import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import routes from '../../../../routes';

import { demoTenantIds } from '../../../../constants/configuration';

import { options } from './constant';

import {
    getIoListAllReportAction,
    deleteIoAction,
    getIoEditIdReportAction,
    addIoReportAction,
    listAdvertiserAction
} from '../../../../actions';
import "../io.scss";

const Card = asyncRoute(() => import('../../../../components/Card'));
const Tabs = asyncRoute(() => import('../../../../components/Tabs'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));

class IO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            advertiserListData: [],
            optionsList: options,
            confirmationOpen: false,
            confirmationInfo: '',
            tableToggle: false
        };
    }



    // eslint-disable-next-line no-unused-react-component-methods/no-unused-react-component-methods
    UNSAFE_componentWillMount() {
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));

        let optionsList = checkTablePermission({ add: PERMISSION.ADMIN.ADVERTISER.ADD, edit: PERMISSION.ADMIN.ADVERTISER.EDIT }, cloneDeep(options));

        this.setState({ optionsList });

        const { history } = this.props;
        if (isEmpty(isAuthenticated)) {
            history.push(routes.preSignIn);
        }
    }

    handleAction = (row, action) => {
        const { match, history } = this.props;
        if (action.type === 'edit') {
            this.handleEdit(row, match, history);
        } else if (action.type === 'delete') {
            this.handleDelete(row, action);
        } else if (action.key === 'rec_active') {
            this.handleStatus(row);
        }
        // else if (action.type === 'sync') {
        //     this.handleSyncCampaign(row, match, history);
        // }
    };

    async handleStatus({ insertionOrderId = '' }) {
        const { tenantId, authToken, userId, getIoEditIdReportAction, addIoReportAction } = this.props;
        if (insertionOrderId) {
            const { responseCode: { status }, responseList } = await getIoEditIdReportAction(tenantId, authToken, userId, { list: insertionOrderId });
            if (status === "Success") {
                responseList.rec_active = responseList.rec_active ? 0 : 1;
                this.handleStatusUpdate(insertionOrderId, responseList, tenantId, authToken, userId, addIoReportAction);
            }
        } else {
            console.log('insertionOrderId empty');
        }
    }

    async handleStatusUpdate(insertionOrderId, payload, tenantId, authToken, userId, addIoReportAction) {
        const { desc = '', status = '' } = await (addIoReportAction(tenantId, authToken, userId, payload, { addup: insertionOrderId }) || '');
        if (status === 'Success') {
            this.getIoListAll();
            return;
        } else {
            const info = { action: { confirmationMessage: desc, type: 'error' } };
            this.toggleModal(info);
        }
    }

    handleEdit = async (row, match, history) => {
        const { tenantId } = this.props;

        if (demoTenantIds.includes(tenantId)) {
            const info = { action: { confirmationMessage: "You don't have permission for this module", type: 'alert' } };
            this.toggleModal(info);
        }
        else {
            localStorage.setItem("editId", JSON.stringify(row.id));
            localStorage.removeItem("advertiserPlatform");
            localStorage.removeItem("googleAds");
            localStorage.removeItem("loginClicked");
            await history.push(`${match.path}/${routes.admin.advertiser.editAdvertiser}`);
        }
    }


    async handleDelete(row) {
        const { deleteIoAction, tenantId, authToken, userId } = this.props;
        let response = await deleteIoAction(tenantId, authToken, userId, { delio: row.insertionOrderId });
        if (response.status === 'Success') {
            this.getIoListAll();
            return;
        }
    }

    toggleModal = (confirmation) => {
        const { confirmationOpen } = this.state;
        this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
    };

    async componentWillMount() {
        await this.listAdvertiser();
    }

    // eslint-disable-next-line no-unused-vars
    confirmationCallBack = (success, info) => {
        this.setState({ confirmationOpen: false });
    };


    // ============ table data ===================
    listAdvertiser = async () => {
        const { tenantId, authToken, userId, payload, listAdvertiserAction, preSignInData } =
            this.props;
        const {
            responseCode: { status = "" },
            response,
        } = await listAdvertiserAction({
            tenantId,
            authToken,
            userId,
            payload
        });

        if (status === "Success") {
            const { responseList } = preSignInData;
            var id = 0;
            var advertiserDetails = response.advertisersPlatforms.map(item => { id++; return { sno: id, advertiser: item.advertiser, id: item.id, inex: item.inex, platforms: item.platforms } })

            const filterType = responseList.find(item => item.tenantId === tenantId);
            if (filterType.tenantType === 'Advertiser') {
                this.setState({ advertiserListData: advertiserDetails })
            } else {
                this.setState({ tableToggle: false });
                this.setState({ advertiserListData: advertiserDetails })
            }
        } else {
            console.log("somthing went wrong");
        }
    }

    // =========== edit advertiser data ===============
    editAdvertiser = (e) => {
        const advertiserID = e.target.id;
        const { history, match } = this.props;
        history.push(`${match.path}/${routes.admin.advertiser.editAdvertiser}/${advertiserID}`);
    }

    // handleAdd = () => {
    //     localStorage.removeItem("editId");
    //     const {match, history} = this.props;
    //     history.push(`${match.path}/${routes.admin.advertiser.newAdvertiserAdd}`);
    // }
    
    render() {
        const tableIoData = this.state.advertiserListData;
        const { match, ioListAll, configurationList } = this.props;
        const { confirmationOpen, confirmationInfo, optionsList, tableToggle, advertiserListData } = this.state;

        const currencyList = get(configurationList.find(currency => currency.attrName === 'CURRENCY'), 'attributeValues', []);
        let ioList = ioListAll.map((item) => {
            item.budgetName = item.budget;
            if (item.currency && item.currency.length) {
                let currency = currencyList.find((itemCurrency) => itemCurrency.key == item.currency[0].currency);
                if (currency) {
                    item.budgetName = `${item.budget.toLocaleString()} (${currency.value})`;
                }
            }
            return item;
        });

        return (
            <>
                {confirmationOpen && (<ModalConfirmation
                    open={confirmationOpen}
                    onClose={this.toggleModal}
                    confirmationInfo={confirmationInfo}
                    handelConfirmationMessage={this.confirmationCallBack}
                />)}
                <div className="main-panel ion">
                    <div className="content-wrapper">
                        <BreadCrumb />
                        <div className="row mt-3">
                            {/* <Card> */}
                                
                            {/* </Card> */}
                            <Card>
                            {
                                    (checkAddPermission(PERMISSION.ADMIN.ADVERTISER.ADD)) && (
                                        <div className="float-right">
                                            {/* <button className="btn btn-primary" onClick={() => this.handleAdd()}><i className="mdi mdi-plus"></i>Add New Advertiser</button> */}
                                            {/* <Link to={`${match.path}/${routes.admin.advertiser.newAdvertiserAdd}`}> <button className="btn btn-primary"><i className="mdi mdi-plus"></i>Add New Advertiser</button></Link> */}
                                        </div>
                                    )
                                }
                                <Tabs container="admin" />
                                <div className="table-responsive mt-4">
                                    <Table
                                        options={optionsList}
                                        data={advertiserListData || []}
                                        handelAction={this.handleAction}
                                    />
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(connect(
    state => ({
        getUserPermissionList: get(state, 'app.getUserPermissionList', []),
        configurationList: get(state, 'app.configurationData.responseList', []),
        ioListAll: get(state, 'app.ioListAllReport.responseList', []),
        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', ''),
        preSignInData: get(state, 'app.preSignInData', [])
    }),
    {
        getIoListAllReportAction,
        deleteIoAction,
        getIoEditIdReportAction,
        addIoReportAction,
        listAdvertiserAction
    }
)(IO));

// ----*  IO propTypes * ----
IO.propTypes = {
    configurationList: PropTypes.array,
    ioListAll: PropTypes.array,
    tenantId: PropTypes.number,
    userId: PropTypes.number,
    authToken: PropTypes.string,
    getIoListAllReportAction: PropTypes.func,
    deleteIoAction: PropTypes.func,
};